import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import CanvasConnectionsEditor from './CanvasConnectionsEditor';
import CanvasPathEditor from './CanvasPathEditor';
import type { CanvasBoardFieldPatch } from './canvasEditorTypes';
import type { CanvasBoardDetail } from '../types';

const NONE_THEME = '__none__';

interface Props {
  board: CanvasBoardDetail;
  onChange: (patch: CanvasBoardFieldPatch) => void;
}

/** Bundelt de board-brede instellingen: centraal thema, presentatiepad en
 * verbindingen, in een zijpaneel naast de frame-inspector. */
export default function CanvasBoardSettingsPanel({ board, onChange }: Props) {
  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-sm font-semibold text-slate-200">Canvas-instellingen</h3>
        <p className="text-xs text-slate-400">Wijzigingen worden automatisch opgeslagen zodra je een veld verlaat.</p>
      </div>
      <div>
        <Label htmlFor="board-theme">Centraal thema</Label>
        <Select
          value={board.theme_frame_id || NONE_THEME}
          onValueChange={(value: string) => onChange({ theme_frame_id: value === NONE_THEME ? null : value })}
        >
          <SelectTrigger id="board-theme"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value={NONE_THEME}>Geen</SelectItem>
            {board.frames.map((f) => <SelectItem key={f.id} value={f.id}>{f.title || f.id}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div>
        <h4 className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">Presentatiepad</h4>
        <CanvasPathEditor path={board.path} frames={board.frames} onChange={(path) => onChange({ path })} />
      </div>

      <div>
        <h4 className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">Verbindingen</h4>
        <CanvasConnectionsEditor connections={board.connections} frames={board.frames} onChange={(connections) => onChange({ connections })} />
      </div>
    </div>
  );
}
